import axios  from 'axios'
import router from '@/router.js'


// define global vars
var data
if (typeof(token) == 'undefined') {
	var token
	// Check browser support
	if (typeof(Storage) !== 'undefined') {
		if (localStorage.getItem("token") !== null) {
			token = localStorage.getItem("token")
		}
	} else {
		console.log('Sorry, your browser does not support Web Storage...')
	}
}

var apiUrl = '';
var baseUrl = '';

// define url
// if (process.env.NODE_ENV === "development") {
// 	// var apiUrl = `http://localhost/adoptujkravicku_vue/directus-master/public/_`
// 	apiUrl = `http://dev.oktodigital.com/adoptujkravicku/v2/directus-master/public/_`;
// 	if ( window.location.hostname === "localhost") {
// 		apiUrl = `${'https://cors-anywhere.herokuapp.com/'}http://dev.oktodigital.com/adoptujkravicku/v2/directus-master/public/_`
// 	}
// 	baseUrl = 'http://dev.oktodigital.com/adoptujkravicku/v2/npm_vue/dist'
// } else {
	apiUrl = `https://adoptujkravicku.sk/api/public/_`
	baseUrl = 'https://adoptujkravicku.sk/skoly/hra'
// }

// define API const
	const api = axios.create({
		baseURL: apiUrl,
		withCredentials: false, // This is the default
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json'
		}
	})


// error catcher
api.interceptors.response.use(
	function(response) {
		return response
	},
	function(error) {
		console.log('interceptors')
		console.log(error)
		//console.log(error.response.data.error.code)
		//console.log(error.response.data.error.message)

		// blank email
		if (error.response.data.error.code == 4) {
			error.response.data.error.message = "Email nesmie byť prázdny"
		}

		// invalid credentials / email
		if (error.response.data.error.code == 100) {
			//error.response.data.error.message = "Nesprávne prihlasovacie meno alebo heslo"
			error.response.data.error.message = "Na uvedený email nie je zaregistrovaný žiadny účet"
		}

		// expired token
		if (error.response.data.error.code == 102) {
			localStorage.setItem("token", '')
			router.push({ name: 'login' })
		}

		// invalid password
		if (error.response.data.error.code == 108) {
			error.response.data.error.message = "Nesprávne heslo"
		}

		// logged out / access denied
		if (error.response.data.error.code == 300) {
			localStorage.setItem("token", '')
			router.push({ name: 'login' })
		}

		// internal server error
		if (error.response.data.error.code == 500 || error.response.status == 500) {
			localStorage.setItem("token", '')
			router.push({ name: 'login' })
		}

		console.log(error.response)
		return error.response.data.error
})



// define endpoints
export default {
	// LOGIN - ToDo EXPIRED TOKEN
	authenticate(email, password) {
		data = { email: email, password: password }
		return api.post('/auth/authenticate', data)
	},

	saveTokenToSession(usertoken) {
		localStorage.setItem("token", usertoken)
		token = localStorage.getItem("token")
	},

	fbLogin(userData) {
		return api.post('/noauth/account/fbLogin', userData)
	},



	// REGISTER
	register(meno, email, heslo, okres, suhlas1, suhlas2, suhlas3, skupina) {
		data = {
			pouzivatel_name: meno,
			pouzivatel_email: email,
			pouzivatel_password: heslo,
			pouzivatel_okres: okres,
			pouzivatel_suhlas_pravidla_pouzivania: suhlas1,
			pouzivatel_suhlas_osobne_udaje: suhlas2,
			pouzivatel_suhlas_marketing: suhlas3,
			pouzivatel_group: skupina
		}

		return api.post('/noauth/account/register', data)
	},

	// initializeAcl
	initializeAcl() {
		return axios.get('https://api.adoptujkravicku.sk/initroles')
	},



	// PROFIL
	getUserData() {
		return api.get('/items/ci_prihlasenie?fields='+
			// ci_prihlasenie
			'id,'+
			'pouzivatel_email,'+
			// ci_pouzivatel
			'pouzivatel_id.*,'+
			// ci_kravicka
			'pouzivatel_id.kravicky_pouzivatela.id,'+
			'pouzivatel_id.kravicky_pouzivatela.dvor_id,'+
			'pouzivatel_id.kravicky_pouzivatela.dvor_id.id,'+
			'pouzivatel_id.kravicky_pouzivatela.dvor_id.dvor_nazov,'+
			'pouzivatel_id.kravicky_pouzivatela.kravicka_meno,'+
			'pouzivatel_id.kravicky_pouzivatela.kravicka_meno_rodica,'+
			'pouzivatel_id.kravicky_pouzivatela.kravicka_img_hlava,'+
			'pouzivatel_id.kravicky_pouzivatela.kravicka_status,'+
			'pouzivatel_id.kravicky_pouzivatela.kravicka_pozadie_profil,'+
			'pouzivatel_id.kravicky_pouzivatela.kravicka_param_global,'+
			'pouzivatel_id.kravicky_pouzivatela.kravicka_param_cistota,'+
			'pouzivatel_id.kravicky_pouzivatela.kravicka_param_jedlo,'+
			'pouzivatel_id.kravicky_pouzivatela.kravicka_param_pitie,'+
			'pouzivatel_id.kravicky_pouzivatela.kravicka_param_zabava,'+
			'pouzivatel_id.kravicky_pouzivatela.farma_kravicka.herna_farma_id,'+
			// ci_herna_farma
			'pouzivatel_id.farma_pouzivatela.id,'+
			'pouzivatel_id.farma_pouzivatela.herna_farma_kapacita_kraviciek,'+
			// ci_message
			'pouzivatel_id.spravy_pouzivatela.id,'+
			'pouzivatel_id.spravy_pouzivatela.message_title,'+
			'pouzivatel_id.spravy_pouzivatela.message_sprava,'+
			'pouzivatel_id.spravy_pouzivatela.message_flag,'+
			'pouzivatel_id.spravy_pouzivatela.created_at,'+
			// ci_repozitar_albumu
			'pouzivatel_id.album_pouzivatela.*',
			{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},



	// RULETA
	getRuletaLog() {
		var today = this.getCurrentDate(-2)
		return api.get('/items/ci_ruleta_log'+
			'?filter[created_at][between]='+today+' 00:00:00,'+today+' 23:59:59'+
			'&fields=id',
			{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},

	getRuleta() {
		// toto je pre konkrétny produkt v ci_ruleta (Tekvicový prívarok 1ks, kukuričný koktejl 3ks)
        //return api.get('/custom/profil/getRuleta',

        // toto je pre generický produkt v ci_ruleta (recetpy, krmivo,..)
        return api.get('/items/ci_ruleta',
			{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},

	claimReward(pouzivatel_id, ruleta_id) {
		data = { pouzivatel_id: pouzivatel_id, ruleta_id: ruleta_id }

		return api.post('/custom/profil/claimReward',
			data,
			{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},

	setRuletaLog(created_by, pouzivatel_id, ruleta_log_action, ruleta_log_pocet_kusov) {
		data = { created_by: created_by, pouzivatel_id: pouzivatel_id, ruleta_log_action: ruleta_log_action, ruleta_log_pocet_kusov: ruleta_log_pocet_kusov }

		return api.post('/items/ci_ruleta_log',
			data,
			{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},



	// FARMA
	getFarmarStyl() {
		return api.get('/items/ci_farmar_styl',
			{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},

	createFarm(pouzivatel_id, meno_farmara, nazov_farmy, farmar_skin_id, kravicka_id, lat, lng) {
		data = { pouzivatel_id: pouzivatel_id, meno_farmara: meno_farmara, nazov_farmy: nazov_farmy, farmar_skin_id: farmar_skin_id, kravicka_id: kravicka_id, lat: lat, lng: lng }

		return api.post('/custom/farma/createFarm',
			data,
			{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},



	// KRAVIČKY
	countKravicky() {
		return api.get('/noauth/kravicka/countKravicky')
	},

	addCowToFarm(kravicka_id, farma_id, kapacita_kraviciek) {
		data = { kravicka_id: kravicka_id, farma_id: farma_id, kapacita_kraviciek: kapacita_kraviciek }

		return api.post('/custom/kravicka/addCowToFarm',
			data,
			{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},

	removeCowFromFarm(kravicka_id, farma_id) {
		data = { kravicka_id: kravicka_id, farma_id: farma_id }

		return api.post('/custom/kravicka/removeCowFromFarm',
			data,
			{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},

	getKravickaInfo(kravicka_id) {
		data = { kravicka_id: kravicka_id }

		return api.post('/custom/kravicka/getKravickaInfo',
			data,
			{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},

	changeKravickaInfo(kravicka_id, kravicka_meno, kravicka_meno_rodica) {
		data = { kravicka_meno: kravicka_meno, kravicka_meno_rodica: kravicka_meno_rodica }

		return api.patch('/items/ci_kravicka/' + kravicka_id,
			data,
			{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},



	// AKTIVITA
	getPouzivatelLog() {
		return api.get('/items/ci_pouzivatel_log?fields='+
			'id,pouzivatel_log_action,pouzivatel_log_message,created_at'+
			'&limit=10&sort=-created_at',
		 	{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},



	// ŠTATISTIKY
	getStatistiky(column, pouzivatelGroup) {

		let fields = 'fields=' +
			'pouzivatel_meno,' +
			column + ',' +
			'pocet_kraviciek'
		let sort = 'sort=-' + column
		let limit = 'limit=50'
		let filter = 'filter[pouzivatel_suhlas_statistiky]=1&filter[pouzivatel_group]=' + pouzivatelGroup

		return api.get('/items/ci_statistiky_pouzivatel?' + fields + '&' + sort + '&' + limit + '&' + filter,
			{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},

	getKravickaStatistiky(column, pouzivatelGroup) {

		let fields = 'fields=' +
			'pouzivatel_meno,' +
			'kravicka_meno,' +
			column
		let sort = 'sort=-' + column
		let limit = 'limit=50'
		let filter = 'filter[pouzivatel_suhlas_statistiky]=1&filter[pouzivatel_group]=' + pouzivatelGroup

		return api.get('/items/ci_statistiky_kravicka?' + fields + '&' + sort + '&' + limit + '&' + filter,
			{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},



	// SPRÁVY
	getUnreadedMessages() {
		return api.get('/items/ci_message?filter[message_flag][eq]=0',
			{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},

	setMessageAsReaded(message_id) {
		data = { message_flag: 1 }

		return api.patch('/items/ci_message/' + message_id,
			data,
			{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},

	setMessagesAsReaded(pouzivatel_id) {
		return api.get('/custom/profil/messagesReaded',
			{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},



	// ZMENA HESLA
	hashPassword(pwd) {
		// $ci_prihlasenie->pouzivatel_password = password_hash($data['password'], PASSWORD_BCRYPT)
	},

	changePassword(old_password, new_password) {
		data = { old: old_password, new: new_password }

		return api.post('/custom/profil/changePassword',
			data,
			{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},

	resetPassword(email) {
		data = { pouzivatel_email: email }
		return api.post('/noauth/account/resetPassword', data )
	},



	// ÚDAJE
	changePouzivatelInfo(pouzivatel_id, email, meno, okres, s1, s2, s3, s4) {
		data = { pouzivatel_name: meno, pouzivatel_okres: okres, pouzivatel_suhlas_reklama: s1,
				pouzivatel_suhlas_info: s2, pouzivatel_suhlas_info_kravicka: s3,
				pouzivatel_suhlas_statistiky: s4 }

		return api.patch('/items/ci_pouzivatel/' + pouzivatel_id,
			data,
			{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},



	// KRAVIČKA
	getKravickaData(kravicka_id) {
		return api.get('/items/ci_kravicka'+
			'?filter[id][eq]=' + kravicka_id +
			'&fields=*,'+
			//'repozitar_kravicky.*,'+
			'repozitar_kravicky.id,'+
			'repozitar_kravicky.repozitar_kravicky_category,'+
			'repozitar_kravicky.repozitar_kravicky_usage_type,'+
			'repozitar_kravicky.herny_produkt_id.*,'+
			'repozitar_kravicky.herny_produkt_id.herny_produkty_animacie_id.*,'+
			'ean_kravicky.id,'+
			'dvor_id.id,'+
			'dvor_id.dvor_nazov,'+
			'satnik_kravicky.satnik_produkt_id,'+
			'satnik_kravicky.repozitar_satnika_used,' +
			'kravicka_pozadie.*',
			{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},



	// ADOPCIA
	setKravickaAdopcia(kravicka_id, kravicka_meno, kravicka_meno_rodica, pouzivatel_id, created_by) {
		var today = this.getCurrentDate(0)
		data = { kravicka_id: kravicka_id, kravicka_meno: kravicka_meno, kravicka_meno_rodica: kravicka_meno_rodica, kravicka_status: '1', kravicka_zaciatok_adopcie: today + ' 00:00:00', pouzivatel_id: pouzivatel_id, created_by: created_by }

		return api.post('/custom/kravicka/reserveCow',
			data,
			{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},

	getEanCodes(kravicka_id, typ) {
		return api.get('/items/ci_ean_changing_log'+
			'?filter[kravicka_id][eq]=' + kravicka_id +
			'&filter[transaction_type][eq]=' + typ +
			'&fields=ean_code',
			{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},

	getGlobalSettings(typ) {
		return api.get('/items/ci_global_system_settings'+
			'?filter[param_name][eq]=' + typ +
			'&fields=param_value',
			{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},



    // ANIMÁCIE / VIDEÁ
    getAnimacie() {
        return api.get('/items/ci_kravicka_animacia?filter[kravicka_animacia_povolena][eq]=1',
            { headers: {'Authorization' : 'Bearer ' + token} }
        )
    },

    saveAnimacieToSession(array) {
        sessionStorage.setItem("animacie", array)
    },

    getAnimacieFromSession() {
        if (sessionStorage.getItem("animacie") !== null) {
            return sessionStorage.getItem("animacie")
        }
        return "empty"
    },



	// OBCHOD
	getObchodData() {
		return api.get('/items/ci_herny_produkt?filter[herny_produkt_povoleny][eq]=1&fields=*.*',
			{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},

	buyProduct(kravicka_id, herny_produkt_id) {
		data = { kravicka_id: kravicka_id, herny_produkt_id: herny_produkt_id }

		return api.post('/custom/kravicka/buyProduct',
			data,
			{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},

    useProduct(pouzivatel_id, kravicka_id, produkt_id, repozitar_id, usage_type, param_jedlo, param_pitie, param_zabava, param_cistota, param_state, pozadie_profil) {
        data = {
            pouzivatel_id: pouzivatel_id,
            kravicka_id: kravicka_id,
            produkt_id: produkt_id,
            repozitar_id: repozitar_id,
            usage_type: usage_type,
            param_jedlo: param_jedlo,
            param_pitie: param_pitie,
            param_zabava: param_zabava,
            param_cistota: param_cistota,
            param_state: param_state,
			pozadie_profil: pozadie_profil
        }

        return api.post('/custom/kravicka/useProduct',
            data,
            { headers: {'Authorization' : 'Bearer ' + token} }
        )
    },

	eanExchange(type, group, dvor_id, ean_code, kravicka_id, pouzivatel_id, pouzivatel_name, pouzivatel_email) {
		data = {
			type: type,
			group: group,
			dvor_id: dvor_id,
			ean_code: ean_code,
			kravicka_id: kravicka_id,
			pouzivatel_id: pouzivatel_id,
			pouzivatel_name: pouzivatel_name,
			pouzivatel_email: pouzivatel_email
		}

		return api.post('/custom/kravicka/eanExchange',
			data,
			{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},



	// ŠATNÍK
	getSatnikData() {
		return api.get('/items/ci_satnik_produkt?fields='+
			'*.*',
			{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},

    buySatnikProduct(kravicka_id, produkt_id) {
        data = { kravicka_id: kravicka_id, produkt_id: produkt_id }

        return api.post('/custom/kravicka/buySatnikProduct',
            data,
            { headers: {'Authorization' : 'Bearer ' + token} }
        )
    },

    useSatnikProduct(kravicka_id, produkt_id, kategoria_id) {
        data = { kravicka_id: kravicka_id, produkt_id: produkt_id, kategoria_id: kategoria_id }

        return api.post('/custom/kravicka/useSatnikProduct',
            data,
            { headers: {'Authorization' : 'Bearer ' + token} }
        )
    },

    hideSatnikProduct(kravicka_id, produkt_id) {
        data = { kravicka_id: kravicka_id, produkt_id: produkt_id }

        return api.post('/custom/kravicka/hideSatnikProduct',
            data,
            { headers: {'Authorization' : 'Bearer ' + token} }
        )
    },

	satnikFbShare(pouzivatel_id, kravicka_id, blob) {
		let imageData = new FormData()
		imageData.append('pouzivatel_id', pouzivatel_id)
		imageData.append('kravicka_id', kravicka_id)
		imageData.append('shareImage', blob)

		return api.post('/custom/kravicka/satnikFbShare',
			imageData,
			{ headers: { 'Authorization' : 'Bearer ' + token, 'Content-Type': 'multipart/form-data; boundary=${blob._boundary}' } }
		)
	},


	// ALBUM
	getAlbumProgress() {
		return api.get('/custom/album/getProgress',
		 	{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},

	getAlbumData(typ) {
		// len v prípade že chceme tabuľku prepojenú na ci_kravicka
		/*if (typ == 'kravicky') {
			return api.get('/custom/album/getKravicky',
			 	{ headers: {'Authorization' : 'Bearer ' + token} }
			)
		}*/

		return api.get('/items/ci_album_' + typ,
		 	{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},

	setAlbumProgress(pouzivatel_id, category, item_id) {
		data = { pouzivatel_id: pouzivatel_id, category: category, item_id: item_id }

		return api.post('/custom/album/setProgress',
			data,
			{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},

	collectReward(repo_id) {
		/*data = { repozitar_albumu_collected: 1 }

		return api.patch('/items/ci_repozitar_albumu/' + repo_id,
			data,
			{ headers: {'Authorization' : 'Bearer ' + token} }
		)*/

		data = { repo_id: repo_id }

		return api.post('/custom/album/collectReward',
			data,
			{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},

    getReceptInfo(recept_id) {
        return api.get('/items/ci_album_recepty/' + recept_id,
            { headers: {'Authorization' : 'Bearer ' + token} }
        )
    },

    checkAchievementProgress(profil, album_uspechy_id) {
        var current = 0
        var max = 0

        var key = profil.pouzivatel_id.album_pouzivatela.findIndex(repo =>
            repo.album_item_id == album_uspechy_id && repo.repozitar_albumu_category == "uspechy"
        )

        if (key >= 0) {
            current = parseInt(profil.pouzivatel_id.album_pouzivatela[key].repozitar_albumu_current)
            max     = parseInt(profil.pouzivatel_id.album_pouzivatela[key].repozitar_albumu_max)
        }

		if (key < 0) {
			return -1
        } else if (current < max) {
        	return key
        } else {
            return -2
        }
    },

    setAchievementProgress(profil, album_uspechy_id) {
        data = { pouzivatel_id: profil.pouzivatel_id.id, category: 'uspechy', item_id: album_uspechy_id }

        return api.post('/custom/album/setProgress',
            data,
            { headers: {'Authorization' : 'Bearer ' + token} }
        )
    },



	// PEXESO
	getPexesoObtiaznosti() {
		return api.get('/items/ci_pexeso_obtiaznost',
			{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},

	getPexesoObtiaznost(obtiaznost_id) {
		return api.get('/items/ci_pexeso_obtiaznost/' + obtiaznost_id,
			{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},

	getPexesoMotivy() {
		return api.get('/items/ci_pexeso_motiv',
			{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},

	getPexesoMotiv(motiv_id) {
		return api.get('/items/ci_pexeso_motiv/' + motiv_id,
			{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},

	setPexesoResult(obtiaznost_id, motiv_id, pouzivatel_id, steps, stopWatchSeconds) {
		data = {
			pouzivatel_id: pouzivatel_id,
			pexeso_leaderboard_obtiaznost_id: obtiaznost_id,
			pexeso_leaderboard_motiv_id: motiv_id,
			pexeso_leaderboard_pocet_tahov: steps,
			pexeso_leaderboard_cas: stopWatchSeconds
		}

		return api.post('/items/ci_pexeso_leaderboard',
			data,
			{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},

    getPexesoLeaderboard(obtiaznost_id) {
        let fields = 'fields=*.*'
	    let filter = 'filter[pexeso_leaderboard_obtiaznost_id]=' + obtiaznost_id
	    let limit = 'limit=10'
	    let sort = 'sort=pexeso_leaderboard_cas,pexeso_leaderboard_pocet_tahov'

	    return api.get('/items/ci_pexeso_leaderboard' + '?' + fields + '&' + filter + '&' + limit + '&' + sort,
          { headers: {'Authorization' : 'Bearer ' + token} }
            )
    },

	// SLIDER PUZZLE
	getSliderPuzzleObtiaznosti() {
		return api.get('/items/ci_slider_puzzle_obtiaznost',
			{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},

	getSliderPuzzleObtiaznost(obtiaznost_id) {
		return api.get('/items/ci_slider_puzzle_obtiaznost/' + obtiaznost_id,
			{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},

	getSliderPuzzleMotivy() {
		return api.get('/items/ci_slider_puzzle_motiv',
			{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},

	getSliderPuzzleMotiv(motiv_id) {
		return api.get('/items/ci_slider_puzzle_motiv/' + motiv_id,
			{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},

	setSliderPuzzleResult(obtiaznost_id, motiv_id, pouzivatel_id, steps, stopWatchSeconds) {
		data = {
			pouzivatel_id: pouzivatel_id,
			slider_puzzle_leaderboard_obtiaznost_id: obtiaznost_id,
			slider_puzzle_leaderboard_motiv_id: motiv_id,
			slider_puzzle_leaderboard_pocet_tahov: steps,
			slider_puzzle_leaderboard_cas: stopWatchSeconds
		}

		return api.post('/items/ci_slider_puzzle_leaderboard',
			data,
			{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},

	getSliderPuzzleLeaderboard(obtiaznost_id) {
		let fields = 'fields=*.*'
		let filter = 'filter[slider_puzzle_leaderboard_obtiaznost_id]=' + obtiaznost_id
		let limit = 'limit=10'
		let sort = 'sort=slider_puzzle_leaderboard_cas,slider_puzzle_leaderboard_pocet_tahov'

		return api.get('/items/ci_slider_puzzle_leaderboard' + '?' + fields + '&' + filter + '&' + limit + '&' + sort,
			{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},




	// INÉ
	getCurrentDate(substr){
		//var today = $.datepicker.formatDate("yy-mm-dd", new Date())
        var today = new Date()
        var dd = String(today.getDate()).padStart(2, '0')
        var mm = String(today.getMonth() + 1).padStart(2, '0')
        var yy = today.getFullYear().toString().substr(substr)
        return yy + '-' + mm + '-' + dd
	},

	getApng(name) {
		return api.get(
			baseUrl + '/assets/animations/' + name + '.png',
			{
					responseType: 'arraybuffer'
			}
		)
	},

	updateZabava(pouzivatelId, percentaZabavy) {
		data = {
			pouzivatelId: pouzivatelId,
			percentaZabavy: percentaZabavy
		}

		return api.post('/custom/kravicka/updateZabava',
			data,
			{ headers: {'Authorization' : 'Bearer ' + token} }
		)
	},

    getAchievementStastneKravicky(pouzivatel_id) {
        data = {
            pouzivatel_id: pouzivatel_id
        }

        return api.post('/custom/kravicka/achievementStastneKravicky',
            data,
            { headers: {'Authorization' : 'Bearer ' + token} }
        )
	}

}
